import React from "react";
import Label from "./Label";
import RemoveButton from "./RemoveButton";

/**
 * props:
 *  - Array authors {id, email, full_name, university: {name}}
 *  - String teamName Is the team being displayed the US or Egyptian team?
 *  - Function removeAuthor
 *  - Boolean editMode
 **/
const AuthorsTable = (props) => {
  // console.log('authors', props.authors)
  const authors =
    props.authors && props.authors.length > 0 ? (
      props.authors.map((a) => {
        const removeButton = (
          <td>
            <button
              className="btn btn-danger"
              onClick={(e) =>
                props.removeAuthor({ type: "syllabus_assignment", id: a.id }, e)
              }
            >
              Remove Team Member
            </button>
          </td>
        );

        return (
          <tr className="test-author-row" style={{ height: "3rem" }} key={a.id}>
            <td>{a.university ? a.university.name : ""}</td>
            <td>{a.full_name}</td>
            <td>{a.email}</td>
            {props.editMode ? removeButton : null}
          </tr>
        );
      })
    ) : (
      <tr style={{ height: "3rem" }}>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    );
  return (
    <div className="justify-content-left top-buffer sm-font">
      <Label text={props.teamName} />
      <table
        id={`table-${props.teamName.replaceAll(" ", "")}`}
        className="table table-bordered"
      >
        <thead>
          <tr>
            <th scope="col">University</th>
            <th scope="col">Name</th>
            <th scope="col">Email</th>
            {props.editMode ? <th>Actions</th> : null}
          </tr>
        </thead>
        <tbody>{authors}</tbody>
      </table>
    </div>
  );
};

export default AuthorsTable;
